import http from './reddit'
// operatorGroup
export default {
  // 新增操作員組
  add: (data) => http.Post(`${http.url.Newcommon}/opergpad`, data),
  // 取得操作員組列表        
  getOperatorGroupList: () => http.Get(`${http.url.Newcommon}/opergplt`),
  // 取得該操作員組設定           
  getOperatorGroupData: (id = '') => http.Get(`${http.url.Newcommon}/opergpuge/${id}`),
  // 刪除操作員
  remove: (data) => http.Post(`${http.url.Newcommon}/opergpde`, data),
  // 修改該操作員組設定
  modify: (data) => http.Post(`${http.url.Newcommon}/opergpupo`, data)
}